"use client";

import { useStore } from "@/hooks/use-store";
import styles from "./Modal.module.scss";
import { useEffect } from "react";

const Modal = () => {
  const { modal } = useStore();

  useEffect(() => {
    const body = document.querySelector("html");

    if (modal.activeModal !== null) {
      body?.classList.add("disable-scroll");
    } else {
      body?.classList.remove("disable-scroll");
    }
  }, [modal.activeModal]);

  const handleCloseModal = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      modal.closeModal();
    }
  };

  return (
    <>
      {modal.activeModal && (
        <div className={`${styles.dialog} ${styles.active}`}>
          <div className={styles.dialog__wrapper}>
            <div onClick={handleCloseModal} className={styles.dialog__inner}>
              <div className={styles.dialog__content}>
                {modal.showCloseButton && (
                  <button
                    className={styles.close_btn}
                    onClick={() => {
                      modal.closeModal();
                    }}
                  >
                    <svg
                      viewBox="0 0 14 14"
                      fill="currentColor"
                      width="18"
                      height="100%"
                      className={styles.close_btn__icon}
                    >
                      <use href="/images/sprite.svg#close"></use>
                    </svg>
                  </button>
                )}
                {modal.activeModal}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
